export class PassageiroInic {
    id = 0;
    nome = '';
    nascimento: Date = null;
    cpf = '';
    telefone = '';
    celular = '';
    email = '';
    obs = '';
}